/**
 * Omnidesk CAPI Helper — Shopify Theme Snippet
 *
 * 1. Captures fbp/fbc cookies and fbclid from URL,
 *    injects as cart attributes for server-side Purchase matching.
 * 2. Sends AddToCart events to server-side CAPI endpoint.
 *
 * Add to theme.liquid before </head>:
 *   <script src="{{ 'omnidesk-capi-helper.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  var CAPI_HOST = 'https://omnidesk-capi.vercel.app';

  // Read a cookie by name
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  // Get URL parameter
  function getParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  // Build fbc from fbclid if Meta didn't set the cookie
  function getFbc() {
    var fbc = getCookie('_fbc');
    if (fbc) return fbc;

    var fbclid = getParam('fbclid');
    if (fbclid) {
      fbc = 'fb.1.' + Date.now() + '.' + fbclid;
      // Set the cookie ourselves (first-party, 90 days)
      var expires = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = '_fbc=' + fbc + '; expires=' + expires + '; path=/; SameSite=Lax';
      return fbc;
    }
    return null;
  }

  // Capture Meta cookies and inject into cart attributes
  function captureMetaCookies() {
    var fbp = getCookie('_fbp');
    var fbc = getFbc();

    if (!fbp && !fbc) return;

    var attributes = {};
    if (fbp) attributes['_omni_fbp'] = fbp;
    if (fbc) attributes['_omni_fbc'] = fbc;
    attributes['_omni_user_agent'] = navigator.userAgent;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () {});
  }

  // Listen for AddToCart events and send server-side CAPI
  function listenForAddToCart() {
    // Intercept Shopify AJAX add-to-cart
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var options = arguments[1];

      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1 && options && options.method === 'POST') {
        // Clone the response to read it
        return originalFetch.apply(this, arguments).then(function (response) {
          var cloned = response.clone();
          cloned.json().then(function (data) {
            sendAddToCart(data);
          }).catch(function () {});
          return response;
        });
      }

      return originalFetch.apply(this, arguments);
    };

    // Also listen for traditional form submits to /cart/add
    var originalXHR = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (method === 'POST' && typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        this.addEventListener('load', function () {
          try {
            var data = JSON.parse(this.responseText);
            sendAddToCart(data);
          } catch (e) {}
        });
      }
      return originalXHR.apply(this, arguments);
    };
  }

  function sendAddToCart(cartItem) {
    if (!cartItem || !cartItem.product_id) return;

    var fbp = getCookie('_fbp');
    var fbc = getCookie('_fbc');

    var payload = {
      product_id: cartItem.product_id.toString(),
      value: parseFloat(cartItem.price) / 100, // Shopify returns price in cents
      currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'SGD',
      source_url: window.location.href,
      event_id: 'atc_' + cartItem.product_id + '_' + Date.now(),
      user_agent: navigator.userAgent,
    };

    if (fbp) payload.fbp = fbp;
    if (fbc) payload.fbc = fbc;

    // Send beacon to CAPI server
    if (navigator.sendBeacon) {
      navigator.sendBeacon(
        CAPI_HOST + '/events/add-to-cart',
        new Blob([JSON.stringify(payload)], { type: 'application/json' })
      );
    } else {
      fetch(CAPI_HOST + '/events/add-to-cart', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(function () {});
    }
  }

  // Run on DOM ready
  function run() {
    captureMetaCookies();
    listenForAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
